import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Clock, Mail, ArrowUpRight } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-white" data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-138">
            Get in Touch
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-139">
            Whether you're a business looking for recovery solutions or a
            consumer with questions about your account, our team is here to
            help.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12" data-id="element-140">
          {/* Contact Info Cards */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="grid sm:grid-cols-2 gap-6" data-id="element-141">
            <div className="bg-brand-gray p-6 rounded-xl" data-id="element-142">
              <MapPin className="text-brand-red mb-4" size={28} data-id="element-143" />
              <h3 className="font-bold text-brand-dark mb-2" data-id="element-144">
                Office Location
              </h3>
              <p className="text-brand-muted" data-id="element-145">
                3135 Walden Ave, Suite 4<br data-id="element-146" />
                Depew, NY 14043
              </p>
            </div>

            <div className="bg-brand-gray p-6 rounded-xl" data-id="element-147">
              <Phone className="text-brand-red mb-4" size={28} data-id="element-148" />
              <h3 className="font-bold text-brand-dark mb-2" data-id="element-149">Phone</h3>
              <p className="text-brand-muted" data-id="element-150">
                Toll Free:
                <br data-id="element-151" />
                <a href="tel:888-765-3854" className="text-brand-navy font-semibold hover:text-brand-red transition-colors" data-id="element-152">
                  888-765-3854
                </a>
              </p>
            </div>

            <div className="bg-brand-gray p-6 rounded-xl" data-id="element-153">
              <Clock className="text-brand-red mb-4" size={28} data-id="element-154" />
              <h3 className="font-bold text-brand-dark mb-2" data-id="element-155">Business Hours</h3>
              <p className="text-brand-muted" data-id="element-156">
                Monday - Friday
                <br data-id="element-157" />
                8:00 AM - 5:00 PM EST
              </p>
            </div>

            <div className="bg-brand-gray p-6 rounded-xl" data-id="element-158">
              <Mail className="text-brand-red mb-4" size={28} data-id="element-159" />
              <h3 className="font-bold text-brand-dark mb-2" data-id="element-160">
                General Inquiries
              </h3>
              <p className="text-brand-muted" data-id="element-161">
                For general questions, please call our main office line during
                business hours.
              </p>
            </div>
          </motion.div>

          {/* Map Embed */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative rounded-xl overflow-hidden h-[400px] border border-gray-200 shadow-sm bg-gray-100" data-id="element-162">
            <iframe title="Compass Recovery Group office location" src="https://www.google.com/maps?q=3135+Walden+Ave,+Suite+4,+Depew,+NY+14043&output=embed" className="absolute inset-0 w-full h-full border-0 grayscale-[0.2]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-163" />

            {/* Overlay card */}
            <div className="absolute bottom-4 left-4 right-4 sm:right-auto sm:max-w-xs bg-white rounded-lg shadow-lg border border-gray-100 p-4 flex items-start gap-3" data-id="element-164">
              <div className="w-10 h-10 shrink-0 bg-brand-red/10 rounded-full flex items-center justify-center" data-id="element-165">
                <MapPin className="text-brand-red" size={20} data-id="element-166" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-167">
                <p className="font-bold text-brand-navy text-sm leading-tight" data-id="element-168">
                  Compass Recovery Group
                </p>
                <p className="text-xs text-brand-muted mt-0.5 leading-snug" data-id="element-169">
                  3135 Walden Ave, Suite 4<br data-id="element-170" />
                  Depew, NY 14043
                </p>
                <a href="https://www.google.com/maps/dir/?api=1&destination=3135+Walden+Ave,+Suite+4,+Depew,+NY+14043" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 mt-2 text-xs font-semibold text-brand-red hover:text-red-800 transition-colors" data-id="element-171">
                  Get Directions
                  <ArrowUpRight size={14} data-id="element-172" />
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}